import { styled } from '@mui/material/styles';
import Typography from '@mui/material/Typography';

export const Title = styled(Typography)(({ theme }) => ({
  marginBottom: theme.spacing(4),
  marginTop: theme.spacing(4)
}));
